export const CHANNEL_API_RESPONSE_SUCCESS = "CHANNEL_API_RESPONSE_SUCCESS";
export const CHANNEL_API_RESPONSE_ERROR = "CHANNEL_API_RESPONSE_ERROR";
export const UPDATE_CHANNEL_LOADING = "UPDATE_CHANNEL_LOADING";
export const RESET_CHANNEL_ERROR = "RESET_CHANNEL_ERROR";
export const GET_CHANNEL_BY_ID = "GET_CHANNEL_BY_ID";
export const GET_CHANNEL_BY_ACTIVE = "GET_CHANNEL_BY_ACTIVE";
